import AuthorizedRoute from 'Components/AuthorizedRoute';
import { SITE_PAGES } from 'Config';
import { getUserManagingOrgIds } from 'Data/context/Organizations';
import withRouter from 'Lib/hoc/withRouter';
import { Navigate, Route, Routes } from 'react-router';
import { canUserViewAllCores } from 'Util';
import ManageOrgsView from '../ManageOrgsView';
import OrganizationDetailsPage from '../Organizations/OrganizationDetailsPage';

let OrgDetailWithRouter = withRouter(OrganizationDetailsPage);

const Organizations = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.MANAGE_FACILITIES.requiredAuth}>
            {!canUserViewAllCores() && getUserManagingOrgIds()?.length === 1 ? (
              <Navigate
                to={`${SITE_PAGES.MANAGE_FACILITIES.to}/${
                  getUserManagingOrgIds()[0]
                }`}
              />
            ) : (
              <ManageOrgsView />
            )}
          </AuthorizedRoute>
        }
      />
      <Route
        path='/:id'
        element={
          <AuthorizedRoute
            requiredAuth={SITE_PAGES.MANAGE_FACILITIES.requiredAuth}>
            <OrgDetailWithRouter />
          </AuthorizedRoute>
        }
      />
    </Routes>
  );
};

let Page = withRouter(Organizations);
export default Page;
